import React, { useEffect } from 'react'

import { useTranslation } from 'react-i18next'

const AppOpener: React.FC = () => {
  const { t } = useTranslation('appOpener')

  const params = new URLSearchParams(window.location.search)
  const target = params.get('target') || 'activity'
  const deepLink = 'ciclogreen://' + target

  useEffect(() => {
    window.location.href = deepLink

    const timer = window.setTimeout(() => {
      window.location.href = deepLink
    }, 600)

    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="h-[100dvh] flex items-center justify-center bg-gray-50 overflow-hidden px-4">
      <div className="max-w-md w-full bg-white p-6 rounded-xl shadow-md space-y-4">
        <div className="flex justify-center">
          <img
            alt="Ciclogreen Logo"
            src={`${process.env.REACT_APP_URL_S3}/images/logo.png`}
            width={180}
            height={28}
            className="mx-auto"
          />
        </div>

        <div>
          <h1 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            {t('title')}
          </h1>
          <p className="mt-2 text-center text-sm text-gray-600">
            {t('subtitle')}
          </p>
        </div>

        <div className="mt-8 space-y-4">
          <a
            href={deepLink}
            className="w-full flex justify-center py-3 px-4 rounded-full text-sm font-bold text-white hover:brightness-90 transition-all focus:outline-none no-underline"
            style={{ backgroundColor: '#00c8b4' }}
          >
            {t('openApp')}
          </a>

          <p className="text-center text-xs text-gray-500">{t('closeHint')}</p>
        </div>
      </div>
    </div>
  )
}

export default AppOpener
